export default "__VITE_ASSET__CoJ1Wky3__"